import {AfterViewChecked, Component, Input, OnDestroy, inject, ChangeDetectionStrategy} from '@angular/core';
import {IScrollNavigationItem} from './scroll-navigation.data';
import {CategoryScrollSpyService, IScrollSpyHandle, IScrollSpyMarker} from '../../services';

@Component({
    selector: 'app-scroll-navigation',
    templateUrl: './scroll-navigation.component.html',
    styleUrls: ['./scroll-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScrollNavigationComponent implements AfterViewChecked, OnDestroy {
    private scrollSpyService = inject(CategoryScrollSpyService);

    // NOTE - This assumes a sorted list with element references in the order of scrolling
    public navItemValues: IScrollNavigationItem[];
    private initialActiveNavItem?: IScrollNavigationItem;
    private initialNavigation = false;
    private scrollSpyHandle?: IScrollSpyHandle;
    private scrollSpyMarkerCount = 0;

    @Input()
    set navItems(navItems: IScrollNavigationItem[]) {
        this.initialActiveNavItem = navItems.find(navItem => navItem.active);
        this.initialNavigation = true;
        this.navItemValues = navItems;
        this.scrollSpyHandle?.disconnect();
        this.scrollSpyHandle = undefined;
        this.scrollSpyMarkerCount = 0;
    }

    public ngOnDestroy() {
        this.initialNavigation = false;
        this.scrollSpyHandle?.disconnect();
    }

    public ngAfterViewChecked(): void {
        if (this.initialNavigation) {
            if (this.initialActiveNavItem && this.initialNavigation) {
                setTimeout(() => {
                    this.navigateTo(this.initialActiveNavItem);
                }, 1000);
            } else {
                document.scrollingElement.scrollIntoView(true);
            }
            this.initialNavigation = false;
        }

        this.setupScrollSpy();
    }

    public navigateTo(navItem: IScrollNavigationItem): void {
        this.scrollSpyHandle?.navigateTo(navItem.elementId);

        this.navItemValues.forEach((currentNavItem: IScrollNavigationItem, index: number) => {
            // Note - This scroll padding is made specifically for a the quickscan page
            // This logic needs to be made better if we want to make this a universal component
            const scrollPadding = index !== this.navItemValues.length - 1 ? -120 : 0;

            if (currentNavItem.elementId === navItem.elementId) {
                const element = document.getElementById(navItem.elementId);
                if (element === null) {
                    return;
                }

                element.scrollIntoView(true);
                if (scrollPadding !== 0) {
                    window.scrollBy(0, scrollPadding);
                }
            }
        });
    }

    private setupScrollSpy(): void {
        if (!this.navItemValues?.length) {
            return;
        }

        const markers: IScrollSpyMarker[] = this.navItemValues
            .map((navItem) => ({id: navItem.elementId, element: document.getElementById(navItem.elementId)}))
            .filter((marker): marker is IScrollSpyMarker => marker.element !== null);

        if (markers.length === 0 || markers.length === this.scrollSpyMarkerCount) {
            return;
        }

        this.scrollSpyHandle?.disconnect();
        this.scrollSpyMarkerCount = markers.length;
        this.scrollSpyHandle = this.scrollSpyService.observe(markers, (activeId) => {
            this.navItemValues.forEach((navItem) => {
                navItem.active = navItem.elementId === activeId;
            });
        });
    }

}
